<div class="osc-utils-confrimation-modal__content">
  <p class="osc-utils-confrimation-modal__content-text"> {{data.message}} </p>
</div>
<div class="osc-utils-confrimation-modal__footer">
  <button mat-raised-button (click)="decline()" class="osc-button osc-button--secondary">{{data.declineButtonText}}</button>
  <button mat-raised-button (click)="confirm()" class="osc-button osc-button--primary">{{data.confirmButtonText}}</button>
</div>